import type { ReactElement } from 'react';
import { getFontFamily } from '@/theme/typography';
import { POPOVER_EMPTY_VALUE } from './Cmarkdowntable.constants';
import { extractTextFromNode } from './Cmarkdowntable.helpers';
import type { CmarkdowntableCell } from './Cmarkdowntable.types';
interface CmarkdowntableCompactPreviewRowProps {
    row: CmarkdowntableCell[];
}
export function CmarkdowntableCompactPreviewRow({ row, }: CmarkdowntableCompactPreviewRowProps): ReactElement {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 3, padding: '5px 8px', borderRadius: 5, backgroundColor: 'rgba(255,255,255,0.04)' }}>
      <span style={{ fontFamily: getFontFamily(), color: '#66FEC1', fontWeight: 700, fontSize: 8.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {formatPreviewCell({ row, columnIndex: 0, maxLength: 10 })}
      </span>
      <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: 9, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>
        {formatPreviewCell({ row, columnIndex: 1, maxLength: 10 })}
      </span>
      <span style={{ color: 'rgba(255,255,255,0.9)', fontFamily: getFontFamily(), fontSize: 9, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'right' }}>
        {formatPreviewCell({ row, columnIndex: Math.min(row.length - 1, 2), maxLength: 8 })}
      </span>
      </div>
    );
}
function formatPreviewCell(input: {
    row: CmarkdowntableCell[];
    columnIndex: number;
    maxLength: number;
}): string {
    return extractTextFromNode(input.row[input.columnIndex]?.content).slice(0, input.maxLength)
        || POPOVER_EMPTY_VALUE;
}
